export default __webpack_public_path__ + "fonts/9b33a8defe033cf72335f21a712aab23.ttf";